import _toConsumableArray from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import tabbable from 'tabbable';
import { Icon } from '../Icon/Icon';
import destructiveDialogStyles from './styles/Dialog.Destructive.scss';
import infoDialogStyles from './styles/Dialog.Info.scss';
import warningDialogStyles from './styles/Dialog.Warning.scss';
export var DialogTypes;

(function (DialogTypes) {
  DialogTypes["Info"] = "Info";
  DialogTypes["Destructive"] = "Destructive";
  DialogTypes["Warning"] = "Warning";
})(DialogTypes || (DialogTypes = {}));

function createDialog(displayName, style, dataTest) {
  var DialogKind = /*#__PURE__*/function (_React$Component) {
    _inherits(DialogKind, _React$Component);

    var _super = _createSuper(DialogKind);

    function DialogKind() {
      var _this;

      _classCallCheck(this, DialogKind);

      _this = _super.apply(this, arguments);
      _this.contentRef = React.createRef();
      _this.closeButtonRef = React.createRef();
      _this.state = {
        activeIndex: 0,
        dialogTriggerElement: null
      };

      _this.findTabbableElements = function () {
        var contentTabbableElements = _this.contentRef && _this.contentRef.current ? tabbable(_this.contentRef.current) : [];
        return _this.closeButtonRef && _this.closeButtonRef.current ? [_this.closeButtonRef.current].concat(_toConsumableArray(contentTabbableElements)) : contentTabbableElements;
      };

      _this.handleKeydown = function (event) {
        var activeIndex = _this.state.activeIndex;

        if (event.key === 'Escape') {
          _this.handleClose(event);
        }

        if (event.key === 'Tab') {
          event.preventDefault();

          var tabbableElements = _this.findTabbableElements();

          var nextIndex;

          if (event.shiftKey) {
            nextIndex = activeIndex === 0 ? tabbableElements.length - 1 : activeIndex - 1;
          } else {
            nextIndex = (activeIndex + 1) % tabbableElements.length;
          }

          _this.setState({
            activeIndex: nextIndex
          });

          tabbableElements[nextIndex].focus();
        }

        if (event.key === 'End') {
          event.preventDefault();

          var _tabbableElements = _this.findTabbableElements();

          var _nextIndex = _tabbableElements.length - 1;

          _this.setState({
            activeIndex: _nextIndex
          });

          _tabbableElements[_nextIndex].focus();
        }

        if (event.key === 'Home') {
          event.preventDefault();

          var _tabbableElements2 = _this.findTabbableElements();

          var _nextIndex2 = 0;

          _this.setState({
            activeIndex: _nextIndex2
          });

          _tabbableElements2[_nextIndex2].focus();
        }
      };

      _this.handleClose = function (event) {
        var onClose = _this.props.onClose;

        if (onClose) {
          onClose(event);
        }
      };

      return _this;
    }

    _createClass(DialogKind, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (document) {
          this.setState({
            dialogTriggerElement: document.activeElement
          });
        }

        if (this.closeButtonRef && this.closeButtonRef.current) {
          this.closeButtonRef.current.focus();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var dialogTriggerElement = this.state.dialogTriggerElement;

        if (dialogTriggerElement && dialogTriggerElement.focus) {
          dialogTriggerElement.focus();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            onClose = _this$props.onClose,
            children = _this$props.children;
        return React.createElement("div", {
          "data-test": "dialog-".concat(dataTest)
        }, React.createElement("div", {
          className: style.pageCover
        }), React.createElement("div", {
          className: style.flexy
        }, React.createElement("div", {
          onKeyDown: this.handleKeydown,
          role: "dialog",
          "data-test": "dialog-".concat(dataTest, "-container"),
          className: style.dialogContainer
        }, React.createElement("div", {
          className: style.dialogTopBar
        }, onClose && React.createElement("button", {
          className: style.closeButton,
          "data-test": "dialog-".concat(dataTest, "-close-button"),
          ref: this.closeButtonRef,
          tabIndex: 0,
          role: "button",
          onClick: this.handleClose
        }, React.createElement(Icon, {
          className: style.closeIcon,
          icon: "action-close"
        }))), React.createElement("div", {
          ref: this.contentRef,
          className: style.contentContainer
        }, children))));
      }
    }]);

    return DialogKind;
  }(React.Component);

  DialogKind.displayName = displayName;
  return DialogKind;
}

export var Dialog = {
  Destructive: createDialog('Dialog.destructive', destructiveDialogStyles, 'destructive'),
  Info: createDialog('Dialog.info', infoDialogStyles, 'info'),
  Warning: createDialog('Dialog.warning', warningDialogStyles, 'warning')
};